export enum TooltipDialogSizeEnum {
    smHeight = '440px',
    smWidth = '440px',
    mdHeight = '640px',
    mdWidth = '640px',
};
